<template>
  <div>
    <v-layout row wrap justify-center>
      <!-- mini statistic start -->
      <v-flex md3 sm6 xs6>
        <mini-statistic
          icon="assignment"
          :to="{ name: 'LaporanTraining' }"
          :counter="counterTraining"
          :loaded="!training_init"
          title="Training"
          color="indigo"
        >
        </mini-statistic>
      </v-flex>
      <v-flex md3 sm6 xs6>
        <mini-statistic
          icon="location_city"
          :to="{ name: 'LaporanClient' }"
          :counter="counterClient"
          :loaded="!client_init"
          title="Client"
          color="red"
        >
        </mini-statistic>
      </v-flex>
      <v-flex md3 sm6 xs6>
        <mini-statistic
          icon="directions_run"
          :to="{ name: 'LaporanTrainer' }"
          :counter="counterTrainer"
          :loaded="!trainer_init"
          title="Trainer"
          color="light-blue"
        >
        </mini-statistic>
      </v-flex>
      <v-flex md3 sm6 xs6>
        <mini-statistic
          icon="assignment"
          :to="profil.role == 'DIREKSI' ? {} : { name: 'Materi' }"
          :counter="counterMateri"
          :loaded="!materi_init"
          title="Materi"
          color="purple"
        >
        </mini-statistic>
      </v-flex>
      <!-- mini statistic end -->
      <v-flex md8 sm12 xs12>
        <v-layout row wrap>
          <v-flex v-if="periode$" xs12>
            <monthly-training></monthly-training>
          </v-flex>
          <v-flex xs12>
            <recent-training :n="9"></recent-training>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md4 sm12 xs12>
        <v-layout row wrap>
          <v-flex xs12 sm6 md12>
            <client-progress :n="5"></client-progress>
          </v-flex>
          <v-flex xs12 sm6 md12>
            <best-trainers :n="5"></best-trainers>
          </v-flex>
          <v-flex xs12 sm6 md12>
            <most-client></most-client>
          </v-flex>
          <v-flex xs12 sm6 md12>
            <most-divisi></most-divisi>
          </v-flex>
          <v-flex xs12 sm6 md12>
            <last-activity :n="5"></last-activity>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-btn
      v-if="profil.role != 'DIREKSI'"
      fixed
      dark
      fab
      bottom
      right
      @click="inputDialog = true"
      color="primary"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <training-input
      :dialog="inputDialog"
      title="TRAINING"
      action="ADD"
      primary_key="id_training"
      primary_field="training"
      :width="950"
      @cancel="inputDialog = false"
      @submitted="inputDialog = false"
    >
    </training-input>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import ClientProgress from "@/components/widgets/list/ClientProgress";
import BestTrainers from "@/components/widgets/list/BestTrainers";
import LastActivity from "@/components/widgets/list/LastActivity";
import MonthlyTraining from "@/components/widgets/chart/MonthlyTraining";
import MostClient from "@/components/widgets/chart/MostClient";
import MostDivisi from "@/components/widgets/chart/MostDivisi";
import RecentTraining from "@/components/widgets/card/RecentTraining";
import TrainingInput from "@/components/pages/input/TrainingInput";
import { mapGetters, mapState } from "vuex";

export default {
  name: "dashboard",
  components: {
    MiniStatistic,
    RecentTraining,
    ClientProgress,
    BestTrainers,
    MonthlyTraining,
    MostClient,
    MostDivisi,
    LastActivity,
    TrainingInput
  },
  data() {
    return {
      inputDialog: false
    };
  },
  computed: {
    ...mapState(["periode$"]),
    ...mapState("auth", ["profil"]),
    ...mapState("trainer", ["trainer_init"]),
    ...mapState("client", ["client_init"]),
    ...mapState("materi", ["materi_init"]),
    ...mapState("training", ["training_init"]),
    ...mapGetters("trainer", ["trainerByLamanPeriode"]),
    ...mapGetters("client", ["clientByLamanPeriode"]),
    ...mapGetters("materi", ["materiByLamanPeriode"]),
    ...mapGetters("training", ["trainingByLamanPeriode"]),
    counterTrainer() {
      return this.getOnlyTotalTraining(this.trainerByLamanPeriode);
    },
    counterMateri() {
      return this.getOnlyTotalTraining(this.materiByLamanPeriode);
    },
    counterClient() {
      return this.getOnlyTotalTraining(this.clientByLamanPeriode);
    },
    counterTraining() {
      return this.trainingByLamanPeriode.length;
    }
  },
  methods: {
    getOnlyTotalTraining(getter) {
      let data = getter.filter(t => {
        return t.total_training > 0;
      });
      return data ? data.length : 0;
    }
  }
};
</script>
